import {TableDefinition} from '../../models';

export const CONTACT_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Contact.id',
    prop: 'id',
    visible: false,
    objectName: 'Contact',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Contact.firstName',
    prop: 'firstName',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.lastName',
    prop: 'lastName',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.email',
    prop: 'email',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.emailStatus',
    prop: 'emailStatus',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
    widthBehavior: 'shrink',
  },
  {
    key: 'API.fields.Contact.phone',
    prop: 'phone',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.phoneNumberStatus',
    prop: 'phoneNumberStatus',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
    widthBehavior: 'shrink',
  },
  {
    key: 'API.fields.Contact.groups',
    prop: 'groupList',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
    sortDisabled: true,
    arrayConfig: {
      displayProperty: 'name',
      maxVisible: 5,
      tagStyle: 'pills',
      moreText: '+{count}',
    },
  },
  {
    key: 'API.fields.Contact.representatives',
    prop: 'representativeList',
    visible: true,
    objectName: 'Contact',
    searchFieldType: 'STRING',
    sortDisabled: true,
    arrayConfig: {
      displayProperty: 'firstName',
      maxVisible: 1,
      tagStyle: 'pills',
      moreText: '+{count}',
      formatter: (item: any) => {
        if (!item) return '';
        const firstName = item.firstName || '';
        const lastName = item.lastName || '';
        return firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName;
      },
    } as any,
  },
  {
    key: 'API.fields.Contact.orgPositions',
    prop: 'orgPositions',
    visible: false,
    sortDisabled: true,
  },
];

export const CONTACT_DATA_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Contact.id',
    prop: 'id',
    visible: false,
    objectName: 'Contact',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Contact.firstName',
    prop: 'firstName',
    visible: true,
    objectName: 'SegmentContact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.lastName',
    prop: 'lastName',
    visible: true,
    objectName: 'SegmentContact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.email',
    prop: 'email',
    visible: true,
    objectName: 'SegmentContact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.phone',
    prop: 'phone',
    visible: true,
    objectName: 'SegmentContact',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Contact.orgPositions',
    prop: 'orgPositions',
    visible: false,
    sortDisabled: true,
    arrayConfig: {
      displayProperty: 'label',
      tagStyle: 'pills',
      maxVisible: 2,
      moreText: '+{count}',
    },
  },
];
